import './css/list-loading-state.css';

// @vue/component
export const ListLoadingState = {
	name: 'ListLoadingState',
	template: `
		<div class="bx-im-list-loading-state__container"></div>
	`,
};
